import { Button } from '@packages/shared/src/ui/Button/Button';
import { useLoyaltyApi } from '@packages/shared/src/hooks/useLoyaltyApi/useLoyaltyApi';
import { useIntl } from 'react-intl';
import useSWRMutation from 'swr/mutation';
import { useSWRConfig } from 'swr';
import { buttonMessages } from '../Payback/messages';
import { usePaybackClient } from '../Payback/usePaybackClient';

export const DeleteLoyaltyConnectionButton = () => {
  const { formatMessage, locale } = useIntl();
  const { mutate } = useSWRConfig();
  const { closeDialogHandler } = usePaybackClient();
  const loyaltyApi = useLoyaltyApi();
  const { trigger } = useSWRMutation(
    'deleteLoyaltyConnection',
    () => loyaltyApi?.deleteLoyaltyConnection({ ecLocale: locale }),
    // important to force a revalidation
    {
      onSuccess: () => {
        mutate('getLoyaltyConnectionStatus');
        closeDialogHandler();
      },
    },
  );
  const handleDeleteLoyaltyConnection = async () => {
    await trigger();
  };
  return (
    <Button onClick={handleDeleteLoyaltyConnection} color="primary">
      {formatMessage(buttonMessages.DialogDeclineButton)}
    </Button>
  );
};
